// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H22V2ZM8 6L8 16H13V18H6V6H8ZM20 13.5H19C17.9846 13.5 17.0109 13.9034 16.2929 14.6213L16 14.9142V18H14V11H16L16 12.3314C16.8987 11.7919 17.9343 11.5 19 11.5H20V13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-adobe-lightroom-filled')
export default class LogoAdobeLightroomFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-adobe-lightroom-filled',
    }
  }
}
